import { render, staticRenderFns } from "./ReporteCuentasXCobrar.vue?vue&type=template&id=00c15fed&scoped=true"
import script from "./ReporteCuentasXCobrar.vue?vue&type=script&lang=js"
export * from "./ReporteCuentasXCobrar.vue?vue&type=script&lang=js"
import style0 from "./ReporteCuentasXCobrar.vue?vue&type=style&index=0&id=00c15fed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c15fed",
  null
  
)

export default component.exports